<template>
  <div :class="wrapperClass">
    <the-mask
      :id="id"
      ref="phoneMask"
      :mask="phoneData.mask"
      :value="innerValue"
      :tokens="plusTokens"
      :placeholder="placeholder"
      :disabled="disabled"
      masked
      type="tel"
      autocomplete="section-form mobile tel"
      inputmode="numeric"
      :class="inputClass"
      @input="onInput"
    />
    <img
      v-if="phoneData.alpha2 && showFlag"
      :src="`/img/flags/${phoneData.alpha2.toLowerCase()}.svg`"
      alt=""
      :class="flagClass"
    />
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';

import {
  getPhoneInfo,
  getCountryByUserTimezone,
} from '@dmlnc/hello_world_phone';

export default {
  name: 'PhoneInput',
  components: { TheMask },

  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    showFlag: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    flagClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      phoneData: {
        mask: '*############',
        alpha2: '',
        valid: false,
        number: '',
      },
      inputFocused: false,
      innerValue: this.value,
      plusTokens: {
        '#': {
          pattern: /\d/,
        },
        '*': {
          pattern: /\d|\+/,
        },
      },
    };
  },
  computed: {
    currentNumber: function () {
      return this.innerValue;
    },
  },
  watch: {
    currentNumber() {
      this.$emit('input', '+' + this.phoneData.number);
      this.$emit('onValidate', {
        number: '+' + this.phoneData.number,
        isValid: this.phoneData.valid,
        country: this.phoneData.alpha2,
      });
    },
  },

  beforeMount() {
    this.visitorCountry = getCountryByUserTimezone();
    if (this.visitorCountry && !this.currentNumber) {
      this.innerValue = `+${this.visitorCountry.countryCode}`;
      this.phoneData = {
        mask: this.visitorCountry.mask,
        alpha2: this.visitorCountry.country?.alpha2,
        valid: false,
        number: this.innerValue,
      };
    }

    this.updateMaskData();
  },
  mounted() {
    this.$refs.phoneMask.$el.onblur = () => {
      this.$emit('onBlur');
      this.inputFocused = false;
    };
    this.$refs.phoneMask.$el.onfocus = () => {
      this.$emit('onFocus');
      this.inputFocused = true;
      setTimeout(this.setFocusToEnd.bind(this), 0);
    };
  },
  methods: {
    onInput(value) {
      this.innerValue = value;
      this.updateMaskData();
      if (this.inputFocused) {
        setTimeout(this.setFocusToEnd.bind(this), 0);
      }
    },

    setFocusToEnd() {
      const length = this.$refs.phoneMask.$el.value.length;
      this.$refs.phoneMask.$el.focus();
      this.$refs.phoneMask.$el.setSelectionRange(length, length);
    },

    updateMaskData() {
      let mask = '+#############';
      const phoneInfo = getPhoneInfo(this.currentNumber);
      if (phoneInfo.mask) {
        mask = phoneInfo.mask;
      }
      this.phoneData = {
        mask: mask,
        alpha2: phoneInfo.country?.alpha2,
        valid: phoneInfo.isValid,
        number: phoneInfo.number,
      };
    },
  },
};
</script>

<style scoped></style>
